/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'project-panel.generic-error.description': '請檢查您的網際網路連線，然後再試一次。',
  'project-panel.generic-error.title': '發生錯誤',
  'project-panel.project-icon-header.update-error-description': '無法更新「{projectName}」的圖示',
  'project-panel.project-icon-header.update-error-title': '發生錯誤。',
  'project-panel.project-panel-expand-field-button.show-less-collapsed-label': '顯示更多欄位',
  'project-panel.project-panel-expand-field-button.show-more-collapsed-label': '顯示較少',
  'project-panel.project-panel-header.title': '專案',
  'project-panel.project-panel-tabs.about-tab-title': '關於',
  'project-panel.project-panel-tabs.decisions-title': '決定',
  'project-panel.project-panel-tabs.learnings-title': '學到的事',
  'project-panel.project-panel-tabs.risks-title': '風險',
  'project-panel.project-panel-tabs.updates-tab-title': '更新',
  'project-panel.project-title.edit-button-label': '編輯專案標題',
  'project-panel.project-title.update-error-description': '無法更新 {projectName} 的內容',
  'project-panel.project-title.update-error-title': '發生錯誤',
  'project-panel.project-title.validation-message': '請為專案命名',
};
